import { ConfigureParams } from "fleet/view/configure-params";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import * as Network from "redux-store/networks/selectors";
import { PRIORITY } from "ui/parameter-form/utils";
import { RefreshView } from "ui/refresh-view";

class ConfigureNetworkParams extends React.PureComponent {
  static get propTypes() {
    return {
      addErrorMessage: PropTypes.func.isRequired,
      apps: PropTypes.array.isRequired,
      network: PropTypes.object.isRequired,
      readonly: PropTypes.bool.isRequired,
      updateParams: PropTypes.func.isRequired,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      refresh: false,
    };

    this.updateParams = this.updateParams.bind(this);
  }

  getSuccessLink() {
    const { network } = this.props;

    return <Link to={`/networks/${network.id}/overview`}>View Network</Link>;
  }

  updateParams(params) {
    const { network, updateParams } = this.props;

    return updateParams({
      params,
      id: network.id,
    }).then(() => {
      this.setState({ refresh: true });
    });
  }

  render() {
    const { network } = this.props;
    const { refresh } = this.state;
    if (refresh) {
      return <RefreshView />;
    }

    return (
      <ConfigureParams
        {...this.props}
        onSubmit={this.updateParams}
        priority={PRIORITY.NETWORK}
        showTestingApps={false}
        successLink={this.getSuccessLink()}
        systemManagedParams={Network.getSystemManagedParams(network)}
      />
    );
  }
}

export { ConfigureNetworkParams };
